export function DateRangeCell({ start, end, className = '' }) {
  const fmt = (s) => {
    if (!s) return '-'
    const d = new Date(s)
    if (isNaN(d)) return '-'
    const dd = String(d.getDate()).padStart(2, '0')
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const yyyy = d.getFullYear()
    const HH = String(d.getHours()).padStart(2, '0')
    const MM = String(d.getMinutes()).padStart(2, '0')
    return `${dd}/${mm}/${yyyy} ${HH}:${MM}`
  }

  return (
    <div className={`flex flex-col text-sm leading-tight ${className}`}>
      <span>
        <span className="text-blue-gray-500">Desde:</span>{' '}
        {fmt(start)}
      </span>
      <span>
        <span className="text-blue-gray-500">Hasta:</span>{' '}
        {fmt(end)}
      </span>
    </div>
  )
}